import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IThreatAssessmentTeam } from '../models/contact';

@Injectable({
  providedIn: 'root'
})
export class ThreatAssessmentSummaryService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getThreatAssessmentSummaryByCaseId(caseId: string): Observable<IThreatAssessmentTeam> {
        const url = environment.apiBaseUrl + endpoints.getThreatAssessmentSummaryByCaseId.replace(':caseId', caseId);
        return this.http.get<IThreatAssessmentTeam>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateThreatAssessmentSummary(data: IThreatAssessmentTeam): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateThreatAssessmentSummary;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}